import React from "react";
import DropDownMenu from "../Shared/DropDownMenu";

const Widget = (props) => {
  const {
    title,
    className,
    Component,
    children,
    icon,
    isFlexColumn,
    customDropDownMenu,
    ...rest
  } = props;

  return (
    <div {...rest} className={`wrapper widget dark-grey ${className}`}>
      <div className="widget-header">
        <div className="widget-title">
          <i className={`icons ${icon} d-inline-block`}></i>
          <h5 className="d-inline-block">{title}</h5>
        </div>

        {customDropDownMenu && (
          <DropDownMenu
            className="portlet-menu"
            BtnClass="portlet-menu-button"
            Items={[
              {
                Text: "Delete Data",
                attr: {
                  href: "#",
                  onClick: () => alert("DeleteData Clicked"),
                },
              },

              {
                Text: "Match Data",
                attr: {
                  onClick: () => alert("Match Data Clicked"),
                },
              },
            ]}
          ></DropDownMenu>
        )}
      </div>
      <div className={`widget-content ${isFlexColumn ? "flex-column" : ""}`}>
        {Component}
      </div>
      {children}
    </div>
  );
};

export default Widget;
